// extracted by mini-css-extract-plugin
module.exports = {"posts":"blogs_posts__rWb15","view__more__wrapper":"blogs_view__more__wrapper__2TIKM","view__more":"blogs_view__more__GobnS"};